"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getBorderColor = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Error = function Error(_ref) {
  var error = _ref.error,
      warning = _ref.warning;
  return error || warning ? _react.default.createElement(ErrorContainer, {
    error: error
  }, _react.default.createElement("p", null, error || warning)) : null;
};

var ErrorContainer = _styledComponents.default.div(_templateObject(), function (_ref2) {
  var theme = _ref2.theme,
      error = _ref2.error;
  return error ? theme.status.error : theme.status.warning;
});

Error.displayName = 'Error';
Error.defaultProps = {
  error: ''
};
Error.propTypes = {
  /** string with errormessage */
  error: _propTypes.string,

  /** string with warningmessage */
  warning: _propTypes.string
};

var getBorderColor = function getBorderColor(error, touched, theme, warning) {
  if (error) return theme.status.error;else {
    if (warning) return theme.status.warning;else if (touched) return theme.status.succes;
  }
  return theme.ui.outline;
};

exports.getBorderColor = getBorderColor;
var _default = Error;
exports.default = _default;